import styled, { css } from "styled-components";

const SaveQuoteStyled = styled.div.attrs({
  className: "save-quote-modal",
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      background-color: ${colors.primary.white};
      border-radius: 16px;

      overflow-y: auto;

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }

      /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      position: relative;

      max-width: 343px;
      padding: 24px;

      ${media.tablet.up} {
        max-width: 1200px;
        width: 90vw;
        padding: 42px;
      }

      .save-quote-modal {
        &__close-button {
          display: block;
          margin: 0 0 16px auto;
          cursor: pointer;
          background: none;
          border: none;
          padding: 0;
        }

        &__content-container {
          padding: 20px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        &__title {
          font-size: 24px;
          font-weight: 700;
          line-height: 28px;
          color: ${colors.primary.gravity};
          margin-bottom: 16px;

          ${media.tablet.up} {
            margin-bottom: 24px;
            font-size: 32px;
            line-height: 36px;
          }
        }

        &__subtitle {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          color: #313131;
          max-width: 672px;
          text-align: center;
        }
      }
    `;
  }}
`;

export default SaveQuoteStyled;
